export const API_BASE_URL = 'https://monitor.dev.masiot.dmsolution.ru/api/v1';
export const WS_URL = 'https://monitor.dev.masiot.dmsolution.ru/ws';